import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { dateFormat, dateTimeFormat, dateTimeFormatIOS } from 'pages/Common'
import TableListWorkers from './TableListWorkers'
import { set } from 'lodash'

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const AddWorkerDetailsModel = ({ modal, toggle, HandWorkListApi, handWorkId, uniqueNo, handworkStatus }) => {
    const { postApi, putApi, getApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [formButtonSumitLoading, setFormButtonSumitLoading] = useState(false)
    const [handleByValue, setHandleByValue] = useState([])
    const [handleByerror, setHandleByError] = useState(false)
    const [userData, setUserData] = useState([])
    const [workerData, setWorkerData] = useState([])
    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());
    const [getWorkDateTimeModel, setGetWorkDateTimeModel] = useState(false)
    const [isActiveWorker, setIsActiveWorker] = useState(false)
    const [workerDataId, setWorkerDataId] = useState(0)
    const [workerId, setWorkerId] = useState(0)
    const [workerOverTimeLog, setWorkerOverTimngLog] = useState(false)
    const [workerTimeLog, setWorkerTimngLog] = useState(false)
    const [workerTimeLogData, setWorkerTimeLogData] = useState([])

    useEffect(() => {
        workersList()
        workerLookup()
    }, [modal])

    const workersList = () => {
        getApi(`HandWorkCosting/worker/list?handworkCostId=${parseInt(handWorkId)}`).then(({ data, status }) => {
            if (status === 200) {
                if (data.length > 0) {
                    let workers = data.map((item) => ({
                        Id: item.Id,
                        WorkerDataId: item.Id,
                        WorkerId: item.WorkerId,
                        WorkerName: item.WorkerName,
                        WorkerCost: item.WorkerCost,
                        IsActive: item.IsActive,
                        Hours: item?.TotalHours,
                    }));
                    setWorkerData(workers)
                } else {
                    setWorkerData([])
                }
            } else {
                toast.error(data, {
                    style: { fontSize: "15px" },
                })
            }
        })
    }

    const workerLookup = () => {
        getApi(`Common/worker/lookup`).then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Name,
                    value: item.Id,
                    cost: item.Cost
                }));
                setHandleByValue([])
                setUserData(options)
            } else {
                toast.error(data, {
                    style: { fontSize: "15px" },
                })
            }
        })
    }

    useEffect(() => {
        if (!modal) {
            setWorkerData([])
            setStartTime(new Date())
            setHandleByValue([])
            setHandleByError(false)
        }
    }, [modal])

    const getTotalHours = () => {
        const totalMinutes = workerData?.reduce((acc, w) => {
            if (!w.Hours) return acc;
            const [h, m] = w.Hours.split(":").map(Number);
            return acc + (h * 60) + m;
        }, 0);

        const totalHours = Math.floor(totalMinutes / 60);
        const totalMins = totalMinutes % 60;

        return `${totalHours}:${totalMins.toString().padStart(2, "0")}`;
    };

    const getTotalCost = () => {
        return workerData.reduce((sum, w) => {
            const cost = w.WorkerCost || 0;
            const [h, m] = (w.Hours || "0:00").split(":").map(Number);
            const decimalHours = h + m / 60; // ✅ convert to decimal hours
            return sum + cost * decimalHours;
        }, 0);
    };

    const handleAddWorker = () => {
        if (!handleByValue || handleByValue.length === 0) {
            setHandleByError(true);
            toast.error("Please select worker");
            return;
        }
        let updatedWorkers = [...workerData];
        let hasDuplicate = false;
        handleByValue.forEach(worker => {
            const existsIndex = updatedWorkers.findIndex(
                (w) => parseInt(w.WorkerId) === parseInt(worker.value)
            );

            if (existsIndex !== -1) {
                toast.error(`Worker "${worker.label}" already exists`);
                hasDuplicate = true;
            } else {
                // ✅ Create new worker row
                const newWorker = {
                    Id: 0,
                    WorkerDataId: 0,
                    WorkerId: worker.value,
                    WorkerName: worker.label,
                    WorkerCost: worker.cost,
                    Hours: 0,
                    StartTime: dateTimeFormatIOS(startTime),
                    IsActive: true
                };
                updatedWorkers.push(newWorker);
            }
        });
        if (!hasDuplicate) {
            setWorkerData(updatedWorkers);
            // setStartTime(new Date());
            setHandleByValue([]);
        }
    };

    const handleCancle = () => {
        toggle()
        setWorkerData([])
    }

    const handleDeleteWorker = (id) => {
        setWorkerData(workerData.filter((w) => w.WorkerId !== id));
    };

    const toggleGetDateTime = () => {
        setGetWorkDateTimeModel(!getWorkDateTimeModel)
    }

    const handleSwitch = (id, workerId, IsActive, value) => {
        if (id) {
            setIsActiveWorker(value)
            setWorkerDataId(id)
            toggleGetDateTime()
            setWorkerId(workerId)
        }
    }

    // worker table columns
    const workerColumn = useMemo(
        () => [
            {
                Header: "Worker",
                Header: () => (
                    <div
                        style={{
                            textAlign: "start",
                        }}
                    >
                        Worker
                    </div>
                ),
                accessor: "Worker",
                Cell: ({ row }) => <p className="mb-0" style={{ textAlign: "start" }}>{row.original?.WorkerName}</p>,
            },
            {
                Header: "Hours",
                Header: () => (
                    <div
                        style={{
                            textAlign: "start",
                        }}
                    >
                        Hours
                    </div>
                ),
                accessor: "Hours",
                width: "10%",
                Cell: ({ row }) => <p className="mb-0" style={{ textAlign: "start" }} >{row.original?.Hours}</p>,
            },
            // {
            //     Header: "Cost",
            //     Header: () => (
            //         <div
            //             style={{
            //                 textAlign: "right",
            //             }}
            //         >
            //             Cost
            //         </div>
            //     ),
            //     accessor: "WorkerCost",
            //     width: "10%",
            //     Cell: ({ row }) => {
            //         return (
            //             <div style={{
            //                 display: "flex",
            //                 alignItems: "end",
            //                 justifyContent: "end",
            //                 textAlign: "end"
            //             }}>
            //                 <i className="mdi mdi-currency-inr"></i>
            //                 {new Intl.NumberFormat('en-IN', {
            //                     currency: 'INR',
            //                     minimumFractionDigits: 2,
            //                 }).format(row?.original?.WorkerCost || 0)}
            //             </div>
            //         )
            //     },
            // },
            {
                Header: "Total Cost",
                Header: () => (
                    <div style={{ textAlign: "right" }}>
                        Total Cost
                    </div>
                ),
                accessor: "TotalWorkerCost",
                width: "12%",
                Cell: ({ row }) => {
                    const totalHoursStr = row?.original?.Hours || "0:00";
                    const [h, m] = totalHoursStr.split(":").map(Number);
                    const decimalHours = h + (m / 60); // ✅ convert to decimal hours
                    const totalCost = decimalHours * (row?.original?.WorkerCost || 0);

                    return (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "end",
                                justifyContent: "end",
                                textAlign: "end",
                            }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat("en-IN", {
                                currency: "INR",
                                minimumFractionDigits: 2,
                            }).format(totalCost.toFixed(2))}
                        </div>
                    );
                },
            },
            {
                Header: "Is Active",
                width: "9%",
                accessor: "IsActive",
                disableSorting: true,
                Cell: ({ row }) => (
                    <FormGroup switch className="d-flex justify-content-center">
                        <Input
                            type="switch"
                            disabled={handworkStatus == 4 || handworkStatus == 1}
                            id={`IsActive_${row.original.Id}`}
                            defaultChecked={row.original.IsActive}
                            onClick={e => {
                                handleSwitch(row.original.Id, row.original.WorkerId, row.original.IsActive, e.target.checked)
                            }}
                        />
                    </FormGroup>
                ),
            },
            {
                Header: "Action",
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                accessor: "action",
                width: "13%",
                Cell: ({ row }) => (
                    <ul className="list-unstyled gap-1 mb-0 d-flex justify-content-center gap-2">

                        {handworkStatus != 1 &&
                            <>
                                <li className="mytooltip" onClick={() => handleWorkerTimingLog(row.original.WorkerDataId)}>
                                    <i
                                        style={{ color: "green", fontSize: "14px", marginTop: "2px" }}
                                        className="fas fa-business-time"></i>
                                    <span className="mytext">Time Log</span>
                                </li>
                            </>
                        }
                        {handworkStatus == 2
                            ?
                            <>
                                <li className="mytooltip" onClick={() => handleWorkerOverTimingLog(row.original.WorkerId, row.original.WorkerDataId)}>
                                    <i
                                        style={{ color: "#556ee6" }}
                                        className="fs-6  fas fa-user-clock"></i>
                                    <span className="mytext">Over Time</span>
                                </li>
                            </>
                            :
                            <>
                                <li className="mytooltip">
                                    <i
                                        className="fs-6  fas fa-user-clock"
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Over Time</span>
                                </li>
                            </>
                        }
                        {handworkStatus != 1
                            ?
                            <>
                                <li className="mytooltip">
                                    <i
                                        className={`fs-6 fas fa-trash-alt btn-delete`}
                                        style={{ cursor: "not-allowed", color: "#808080b3" }}
                                    ></i>
                                    <span className="mytext">Delete</span>
                                </li>
                            </>
                            :
                            <>
                                <li className="mytooltip" onClick={() => handleDeleteWorker(row.original.WorkerId)}>
                                    <i className="fs-6 fas fa-trash-alt btn-delete"></i>
                                    <span className="mytext">Delete</span>
                                </li>
                            </>
                        }
                    </ul>
                ),
            },
        ],
        [workerData, getWorkDateTimeModel]
    );

    const workerTimeLogColumn = useMemo(
        () => [
            {
                Header: "Start Time",
                Header: () => (
                    <div
                        style={{
                            textAlign: "start",
                        }}
                    >
                        Start Time
                    </div>
                ),
                accessor: "StartTime",
                Cell: ({ row }) => {
                    return (
                        <>
                            <p className="mb-0" style={{ textAlign: "start" }}>{dateTimeFormat(row.original?.StartTime, "dd-MM-yyyy HH:mm tt ")}</p>
                        </>
                    )
                }
            },
            {
                Header: "End Time",
                Header: () => (
                    <div
                        style={{
                            textAlign: "start",
                        }}
                    >
                        End Time
                    </div>
                ),
                accessor: "EndTime",
                Cell: ({ row }) => {
                    return (
                        <>
                            <p className="mb-0" style={{ textAlign: "start" }}>{dateTimeFormat(row.original?.EndTime, "dd-MM-yyyy HH:mm tt ")}</p>
                        </>
                    )
                }
            },
            {
                Header: "Hours",
                Header: () => (
                    <div
                        style={{
                            textAlign: "start",
                        }}
                    >
                        Hours
                    </div>
                ),
                accessor: "Hours",
                width: "10%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <p className="mb-0" style={{ textAlign: "start" }} >{row.original?.Hours}</p>
                        </>
                    )
                }
            },
        ],
        [workerTimeLogData]
    );

    const handleSubmit = () => {
        if (workerData.length === 0) {
            toast.error("Please add at least one worker", {
                style: { fontSize: "15px" },
            })
            return;
        }
        setformSumitLoading(true)
        const payload = {
            Workers: workerData.map(w => ({
                Id: w?.Id,
                WorkerId: w.WorkerId,
                StartDateTime: handworkStatus == 2 && w?.Id == 0 ? dateTimeFormatIOS(startTime) : null,
            })),
            HandWorkId: handWorkId,
        }
        postApi("HandWorkCosting/add/workers", payload).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status === 200) {
                toast.success("Successfully Added", {
                    style: { fontSize: "15px" },
                })
                toggle()
                if (HandWorkListApi != '') {
                    HandWorkListApi()
                }
                setWorkerData([])
                setStartTime(new Date())
                setHandleByValue([])
                setHandleByError(false)
            }
            else {
                toast.error(data, {
                    style: { fontSize: "15px" },
                })
            }
        })
    }

    const handleSubmitWorker = () => {
        setFormButtonSumitLoading(true)
        putApi("HandWorkCosting/workers/active-inacive",
            {
                Id: parseInt(workerDataId),
                IsActive: isActiveWorker,
                DateTime: dateTimeFormatIOS(startTime),
                workerId: workerId
            }).then(({ data, status }) => {
                setFormButtonSumitLoading(false)
                if (status === 200) {
                    setGetWorkDateTimeModel(false)
                    setWorkerData(prev =>
                        prev.map(w =>
                            w.Id === workerDataId ? { ...w, IsActive: isActiveWorker } : w
                        )
                    );
                    toggle()
                    toast.success("worker sucessfully changed", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                } else {
                    $("#IsActive_" + workerDataId + "").prop("checked", isActiveWorker)
                    ErrorModel.errormodel({
                        title: "Verify Worker",
                        text: data,
                    })
                }
            })
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    const handleWorkerOverTimingLog = (workerId, workerDataId) => {
        setWorkerDataId(workerDataId)
        setWorkerId(workerId)
        handleWorkerOverTimingLogToggle()
    }

    const handleWorkerTimingLog = (workerDataId) => {
        setWorkerDataId(workerDataId)
        getApi(`Common/worker/time-log?workerDataId=${parseInt(workerDataId)}`).then(({ data, status }) => {
            if (status === 200) {
                if (data.length > 0) {
                    setWorkerTimeLogData(data)
                } else {
                    setWorkerTimeLogData([])
                }
            } else {
                toast.error(data, {
                    style: { fontSize: "15px" },
                })
            }
        })
        handleWorkerTimingLogToggle()
    }

    const handleWorkerOverTimingLogToggle = () => {
        setWorkerOverTimngLog(!workerOverTimeLog)
    }

    const handleWorkerTimingLogToggle = () => {
        setWorkerTimngLog(!workerTimeLog)
    }

    const handleSubmitWorkerOverTime = () => {
        setFormButtonSumitLoading(true)
        postApi("HandWorkCosting/worker/add-over-time-log",
            {
                workerDataId: parseInt(workerDataId),
                StartDateTime: dateTimeFormatIOS(startTime),
                EndDateTime: dateTimeFormatIOS(endTime),
            }).then(({ data, status }) => {
                setFormButtonSumitLoading(false)
                if (status === 200) {
                    setWorkerOverTimngLog(false)
                    toast.success("worker over time sucessfully added", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                    setStartTime(new Date())
                    setEndTime(new Date())
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
    }

    return (
        <>
            <Modal
                isOpen={modal}
                toggle={toggle}
                centered={true}
                size="xl"
                style={{ width: !isMobile ? "900px" : "" }}
            >
                <div className="modal-content">
                    <ModalHeader toggle={toggle} tag="h5">
                        {"Add Worker"} (Unique No.: {uniqueNo})
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row className=''>
                                <Col md={4}>
                                    <FormGroup className="mb-0">
                                        <Label className="required">Worker</Label>
                                        <Select
                                            unstyled
                                            styles={handleByerror ? colourStyles1 : colourStyles}
                                            value={handleByValue}
                                            isMulti
                                            onChange={(e) => {
                                                setHandleByValue(e)
                                                setHandleByError(false)
                                            }}
                                            options={userData}
                                            className="select2-selection"
                                        />
                                        {handleByerror ? (
                                            <div className="name-required">
                                                {"Worker is Required"}
                                            </div>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                {handworkStatus == 2 &&
                                    <Col md={3}>
                                        <FormGroup className="mb-2">
                                            <Label
                                                htmlFor="validationCustom03"
                                                className="required"
                                            >
                                                Start Date Time
                                            </Label>
                                            <div className="d-flex date-after" >
                                                <Flatpickr
                                                    className="form-control d-block flatpicker-date"
                                                    placeholder="dd-MM-yyyy"
                                                    options={{
                                                        enableTime: true,
                                                        dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                        time_24hr: true,           // ✅ ensures 24hr mode
                                                        disableMobile: true
                                                    }}
                                                    value={startTime}
                                                    onChange={(e) => { setStartTime(e) }}
                                                />

                                            </div>
                                        </FormGroup>
                                    </Col>
                                }
                                <Col md={2}>
                                    <Button
                                        color="primary"
                                        disabled ={handworkStatus == 5}
                                        className="btn btn-success btn-sm"
                                        type="button"
                                        onClick={handleAddWorker}
                                        style={{ marginTop: "27px", padding: "4px 14px" }}
                                    >
                                        Add
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" className="text-end">
                                    <span className="fw-bold me-3">
                                        Total Hours: {getTotalHours()}
                                    </span>
                                    <span className="fw-bold">
                                        Total Worker Cost: <i className="mdi mdi-currency-inr"></i>
                                        {new Intl.NumberFormat('en-IN', {
                                            currency: 'INR',
                                            minimumFractionDigits: 2,
                                        }).format(Math.round(getTotalCost()))}
                                    </span>
                                </Col>
                            </Row>

                            <Row className="mt-2 mb-2">
                                <Col md="12" className="text-end ">
                                    <TableListWorkers
                                        columns={workerColumn}
                                        data={workerData}
                                        isGlobalFilter={false}
                                        isCreateBooking={false}
                                        customPageSize={10}
                                        allowSalesmanDisplay={false}
                                        className="custom-header-css"
                                    />
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={handleCancle}
                                >
                                    Cancle
                                </Button>
                                {formSumitLoading ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        color="secondary"
                                    >
                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                        Loading
                                    </button>
                                ) : (
                                    <Button
                                        user="primary"
                                        className="btn btn-primary btn-sm "
                                        type="button"
                                        color="primary"
                                        onClick={() => handleSubmit()}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </div>
                        </Form>
                    </ModalBody>
                </div>
            </Modal>

            <Modal
                isOpen={getWorkDateTimeModel}
                toggle={toggleGetDateTime}
                centered={true}
                size="xl"
                style={{ width: !isMobile ? "300px" : "" }}
            >
                <div className="modal-content">
                    <ModalHeader toggle={toggleGetDateTime} tag="h5">
                        Update Worker
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row className=''>
                                <Col md={12}>
                                    <FormGroup className="mb-2">
                                        <Label
                                            htmlFor="validationCustom03"
                                            className="required"
                                        >
                                            {isActiveWorker ? 'Start Date Time' : " End Date Time"}
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                    time_24hr: true,           // ✅ ensures 24hr mode
                                                    disableMobile: true
                                                }}
                                                value={startTime}
                                                onChange={(e) => { setStartTime(e) }}
                                            />

                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={() => { setGetWorkDateTimeModel(false) }}
                                >
                                    Cancle
                                </Button>
                                {formButtonSumitLoading ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        color="secondary"
                                    >
                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                        Loading
                                    </button>
                                ) : (
                                    <Button
                                        user="primary"
                                        className="btn btn-primary btn-sm "
                                        type="button"
                                        color="primary"
                                        onClick={() => handleSubmitWorker()}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </div>
                        </Form>
                    </ModalBody>
                </div>
            </Modal>


            <Modal
                isOpen={workerOverTimeLog}
                toggle={handleWorkerOverTimingLogToggle}
                centered={true}
                size="xl"
                style={{ width: !isMobile ? "500px" : "" }}
            >
                <div className="modal-content">
                    <ModalHeader toggle={handleWorkerOverTimingLogToggle} tag="h5">
                        Add OverTime
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row className=''>
                                <Col md={6}>
                                    <FormGroup className="mb-2">
                                        <Label
                                            htmlFor="validationCustom03"
                                            className="required"
                                        >
                                            Start Date Time
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                    time_24hr: true,           // ✅ ensures 24hr mode
                                                    disableMobile: true
                                                }}
                                                value={startTime}
                                                onChange={(e) => { setStartTime(e) }}
                                            />

                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup className="mb-2">
                                        <Label
                                            htmlFor="validationCustom03"
                                            className="required"
                                        >
                                            End Date Time
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                    time_24hr: true,           // ✅ ensures 24hr mode
                                                    disableMobile: true
                                                }}
                                                value={endTime}
                                                onChange={(e) => { setEndTime(e) }}
                                            />

                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-end">
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={() => { setWorkerOverTimngLog(false) }}
                                >
                                    Cancle
                                </Button>
                                {formButtonSumitLoading ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        color="secondary"
                                    >
                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                        Loading
                                    </button>
                                ) : (
                                    <Button
                                        user="primary"
                                        className="btn btn-primary btn-sm "
                                        type="button"
                                        color="primary"
                                        onClick={() => handleSubmitWorkerOverTime()}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </div>
                        </Form>
                    </ModalBody>
                </div>
            </Modal>

            <Modal
                isOpen={workerTimeLog}
                toggle={handleWorkerTimingLogToggle}
                centered={true}
                size="xl"
                style={{ width: !isMobile ? "500px" : "" }}
            >
                <div className="modal-content">
                    <ModalHeader toggle={handleWorkerTimingLogToggle} tag="h5">
                        Timing Log
                    </ModalHeader>
                    <ModalBody>
                        <TableListWorkers
                            columns={workerTimeLogColumn}
                            data={workerTimeLogData}
                            isGlobalFilter={false}
                            isCreateBooking={false}
                            customPageSize={10000}
                            allowSalesmanDisplay={false}
                            className="custom-header-css"
                        />
                    </ModalBody>
                </div>
            </Modal>
        </>
    )
}

export default AddWorkerDetailsModel
